const useAuthTypes = () =>{
  const LOGIN = 'LOGIN';
  const LOGOUT = 'LOGOUT';
  const LOADER_OFF = 'LOADER_OFF';
  const LOADER_ON = 'LOADER_ON';
  const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
  const SET_MFA_PENDING = 'SET_MFA_PENDING';
  const CLEAR_MFA_PENDING = 'CLEAR_MFA_PENDING';
  const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';
  const UPDATE_SESSION = 'UPDATE_SESSION';

  return {
    LOGIN,
    LOGOUT,
    LOADER_OFF,
    LOADER_ON,
    SET_AUTH_TOKEN,
    SET_MFA_PENDING,
    CLEAR_MFA_PENDING,
    UPDATE_PERMISSIONS,
    UPDATE_SESSION,
  }
};

export default useAuthTypes;
